<template>
  <div class="hue-con">
    <div class="hue-top">
      <!-- log -->
      <h1><Icon type="logo-buffer" /><span>自定义查询</span></h1>
      <!-- name -->

      <div class="hue-top-right">
        <ButtonGroup>
          <Button
            type="primary"
            @click="
              modal1 = true;
              saveAs = false;
            "
          >
            <Tooltip content="保存" placement="bottom">
              <Icon custom="i-custom icon-save" size="20" />
            </Tooltip>
          </Button>
          <Button v-if="isFileBack" type="primary">
            <Poptip placement="bottom" width="50">
              <Icon type="ios-arrow-down" />
              <div
                class="Poptip"
                slot="content"
                @click="
                  modal1 = true;
                  saveAs = true;
                "
              >
                <Icon custom="i-custom icon-save" size="20" />
                <span>另存为 </span>
              </div>
            </Poptip>
          </Button>
        </ButtonGroup>

        <Modal
          v-model="modal1"
          :title="
            !isFileBack
              ? '将查询保存为...'
              : saveAs
              ? '将查询另存为...'
              : '将查询保存为...'
          "
          @on-ok="saveSelect"
        >
          <Form
            ref="formValidate"
            :model="formValidate"
            label-position="right"
            :label-width="80"
          >
            <!-- :rules="ruleValidate" -->
            <FormItem label="名称" prop="name">
              <Input v-model="formValidate.name"></Input>
            </FormItem>

            <FormItem label="描述">
              <Input
                v-model="formValidate.description"
                placeholder="(可选)"
              ></Input>
            </FormItem>
          </Form>
        </Modal>
        <!-- <Button type="primary"> <Icon type="md-more" /></Button> -->
        <Tooltip content="新建查询" placement="bottom">
          <Button @click="newQuery" type="primary">
            <Icon type="md-document" />
          </Button>
        </Tooltip>
      </div>
    </div>
    <!-- sql输入 -->
     <div style="padding: 20px; " class="sqlEditor">
       <SqlEditor ref="sqleditor" @changeTextarea="changeTextarea($event)" style="height: 150px; " />
     </div>
    <!-- 查询时候的按钮 线条变化 -->
    <div v-show="!showLine" class="condition"></div>
    <div
      v-show="showLine"
      class="condition"
      :style="line == 'success' ? 'background:#6BE36B' : 'background:#FE6161'"
    ></div>
    <div v-show="!queries" class="runBox"></div>
    <div v-show="queries" class="runBox">
      <div class="run"></div>
    </div>

    <div class="operate">
      <div class="operate-left">
        <!-- 开始查询 -->
        <!--  -->
        <!-- v-if="!queries" -->
        <Button
          v-if="!queries"
          :disabled="basicInfoForm.sqlMain ? false : true"
          type="primary"
          @click="getExecute"
        >
          <Icon style="margin-right: 5px" type="md-play" />执行查询
        </Button>
        <Button v-else type="error" @click="stopExecute">
          <Icon style="margin-right: 5px" type="md-square" />
          等待...
        </Button>
        <!-- limit -->
        <!-- <Input style="width: 70px; margin-left: 20px" v-model="limit" placeholder="Limit" /> -->
      </div>
      <!-- more -->
      <div class="operate-right" style="display: flex; column-gap: 20px;">
        <!-- 更多 -->
        <Button @click="formaterSql(basicInfoForm.sqlMain)" type="primary">
          <Icon type="md-list" /> 格式化
        </Button>
        <Button @click="clearSql(basicInfoForm.sqlMain)" >
          <Icon type="ios-trash-outline" />
          清除
        </Button>
      </div>
    </div>
    <!-- 查询详情 -->
    <!-- <div class="hue-tabs"> -->
    <Tabs
      ref="tabs"
      :execute="execute"
      :param="param"
      @selectRow="selectRow"
      @selectRowItem="selectItem"
    ></Tabs>
    <!-- </div> -->
  </div>
</template>
<script>
import sqlFormatter from "sql-formatter";
import SqlEditor from "./SqlEditor.vue";
import Tabs from "./tabs.vue";
import api from "@/libs/api";
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  components: {
    SqlEditor,
    Tabs,
  },
  props: {
    // selectStr: String,
  },
  data() {
    return {
      showLine: false,
      line: "success", //提示线
      queries: false, //是否查询
      // limit: 10,
      modal1: false, //保存
      sqlName: "", //name span
      sqlNameShow: false, //name show

      describe: "", //dec span
      describeShow: false, //dec show

      basicInfoForm: {
        sqlMain: "", //sql
      },
      formValidate: {
        name: "",
        description: "",
      }, //保存查询sql的名字和描述
      historyId: "", //添加历史id
      execute: {}, //sql查询结果
      param: {}, //查询参数

      isStop: false, //是否停止查询
      isFileBack: false,
      saveAs: false, //是否另存
      savedfileId: "",

      page: 1,
      pageSize: 10,
    };
  },
  created() {
    // setTimeout(() => {
    //   this.cancel("取消");
    // });
  },
  computed: {
    ...mapState({
      projectId: (state) => state.app.projectId,
    }),
  },
  methods: {
    ...mapMutations(["SET_QUERY_RESULT"]),
    ...mapActions(["getFile", "getHistory", "getSaveStatementAll"]),
    // 点击目录 回显sql
    changeValue(active) {
      this.basicInfoForm.sqlMain =
        "select " + active.split("-")[1] + " from " + active.split("-")[0];
      this.$refs.sqleditor.changeVal(this.basicInfoForm.sqlMain);
      this.isFileBack = false;
      this.saveAs = false;
      this.savedfileId = "";
    },

    // 查询历史回显
    selectRow(content) {
      this.basicInfoForm.sqlMain = content.content;
      this.formValidate.name = content.name; //名字
      this.describe = ""; //描述
      this.setName(content.name);
      this.notSetDescribe();
      this.$refs.sqleditor.changeVal(this.basicInfoForm.sqlMain);
      if (content.name) {
        this.isFileBack = true;
      } else {
        this.isFileBack = false;
      }
      this.saveAs = false;
      this.savedfileId = "";
    },
    // 保存查询回显
    selectItem(el) {
      this.selectRow(el);
      this.formValidate.name = el.name; //名字
      this.formValidate.description = el.description; //描述
      this.setName(el.name);
      this.setDescribe(el.description);
      this.isFileBack = true;
      this.savedfileId = el.id;
    },

    // 文本域改变
    changeTextarea(val) {
      this.basicInfoForm.sqlMain = val;
    },
    // 格式化sql
    formaterSql() {
      let dom = this.$refs.sqleditor;
      dom.editor.setValue(
        sqlFormatter.format(dom.editor.getValue(), {
          language: "n1ql",
        })
      );
    },

    // sql查询
    getExecute() {
      this.isStop = false;
      this.queries = true;
      let params = {
        sql: this.basicInfoForm.sqlMain,
        // limit: this.limit,
      };
      this.param = params;
      api
        .getExecute(this.projectId, params)
        .then((res) => {
          if (!this.isStop) {
            if (res.data.status == 1) {
              this.line = "success";
              // this.$refs.tabs.$refs.history.chgPage(1);
              this.$refs.tabs._data.value = "Results";
              this.$refs.tabs._data.selected = true;
              // if (res.data.fields) {
              this.execute = res.data.fields;
              // } else {
              //   this.execute = {};
              // }
            } else if (res.data.status == 0) {
              // 查询无结果提示
              this.$refs.tabs._data.value = "Results";
              this.$refs.tabs._data.selected = true;
              this.execute = res.data;
            } else {
              this.line = "fail";
              this.$refs.tabs._data.value = "History";
              this.$refs.tabs._data.selected = false;
              this.execute = {};
              this.$Message.error("查询错误");
            }
          }
          this.queries = false;
          this.showLine = true;
          setTimeout(() => {
            this.showLine = false;
          }, 2000);
          // 添加历史
          this.savaExecute(res.data.status);
        })
        .catch((err) => {
          console.log(err);
          this.line = "fail";
          this.$refs.tabs._data.value = "History";
          this.$refs.tabs._data.selected = false;
          this.execute = {};
          this.$Message.error("查询错误");
        });
    },

    // 停止查询
    stopExecute() {
      this.isStop = true;
      let param = "hive";
      api.canelReq(param).then((res) => {
        if (res.data.status == 1) {
          this.$Message.error("查询取消");
          this.queries = false;
        }
      });
    },
    // 添加历史
    savaExecute(status) {
      let param = {
        fileId: this.savedfileId, //保存查询id
        content: this.basicInfoForm.sqlMain,
        success: status == 1 ? true : false,
      };
      api.savaExecute(this.projectId, param).then((res) => {
        if (res.data.status == 1) {
          this.historyId = res.data.fields.id;
          // let hisParam = {
          //   projectId: this.projectId,
          //   page: this.page,
          //   pageSize: this.pageSize,
          // };
          this.$refs.tabs.$refs.history.getHistory();
        }
      });
    },
    // 新建查询
    newQuery() {
      // window.location.reload();
      this.clearSql();
      this.notSetDescribe();
      this.notSetName();
      this.isFileBack = false;
      this.sqlName = "";
      this.describe = "";
    },
    // 清空sql
    clearSql() {
      this.$refs.sqleditor.clearSql();
    },
    // 设置名字
    setName(name) {
      if (name) {
        this.sqlName = name;
      }
      this.sqlNameShow = false;
    },
    // 取消设置名字
    notSetName() {
      this.formValidate.name = ""; //名字
      this.sqlNameShow = false;
    },
    // 设置描述
    setDescribe(description) {
      if (description) {
        this.describe = description;
      } else {
      }
      this.describeShow = false;
    },
    // 取消设置描述
    notSetDescribe() {
      this.formValidate.description = ""; //描述
      this.describeShow = false;
    },
    // 保存查询
    saveSelect() {
      if (this.isFileBack) {
        if (this.saveAs) {
          this.save(); //保存
        } else {
          this.update(); //修改
        }
      } else {
        this.save(); //保存
      }
    },
    // 保存
    save() {
      let params = {
        historyId: this.historyId, //查询后添加历史返回的历史id
        name: this.formValidate.name, //名字
        description: this.formValidate.description, //描述
        content: this.basicInfoForm.sqlMain, //语句
        parentId: "", //是否存在文件夹里，文件夹id
      };
      api.saveStatement(this.projectId, params).then((res) => {
        if (res.data.status == 1) {
          this.getFile(this.projectId);

          this.$refs.tabs.$refs.history.getHistory();
          this.getSaveStatementAll(this.projectId);
          this.$Message.success("保存成功");
        } else {
          this.$Message.error("保存失败");
        }
      });
    },
    // 修改
    update() {
      let params = {
        id: this.savedfileId, //保存查询id
        name: this.formValidate.name, //名字
        description: this.formValidate.description, //描述
        content: this.basicInfoForm.sqlMain, //语句
        parentId: "", //是否存在文件夹里，文件夹id
      };
      api.updateFIle(this.projectId, params).then((res) => {
        if (res.data.status == 1) {
          this.getSaveStatementAll(this.projectId);
          this.$Message.success("修改成功");
        } else {
          this.$Message.error("修改失败");
        }
      });
    },
  },
};
</script>

<style scoped>
>>>.sqlEditor .CodeMirror {
  height: 100%;
  background-color: #F9FAFB;
  border-radius: 5px;
  padding: 10px;
  border: 1px solid #E5E7EB;
}


>>>.sqlEditor  .CodeMirror-gutters {
  border: none;
}
.hue-con {
  height: 100%;
}

.hue-top {
  height: 60px;
  width: 100%;
  display: flex;
  padding: 0 20px;
  border-top: 1px solid #ccc;
  align-items: center;
  justify-content: space-between;
}


.hue-top h1 {
  /* margin: 0 80px 0 20px; */
  font-weight: normal;
  font-size: 20px;
  font-weight: 500;
  display: flex;
  column-gap: 10px;
  align-items: center;
}

.SqlName {
  margin-right: 50px;
}

.name {
  font-weight: bold;
}

.name,
.describe {
  display: inline-block;
  width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #5a656d;
  font-weight: bold;
}

.name:hover,
.describe:hover {
  color: rgb(197, 177, 177);
}

/* .hue-tabs {
  height: 53.5%;
  background: aqua;
} */
.sql-btn {
  margin-top: 10px;
}

.Poptip {
  background: #fff;
  color: #1D2129;
}

.operate {
  width: 97%;
  margin: 8px auto;
  display: flex;
  justify-content: space-between;
}

.more div {
  margin: 8px 0;
}

.runBox {
  width: 100px;
  height: 5px;
  margin-left: 15px;
  position: relative;
  /* background: rgb(139, 121, 121); */
}

.condition {
  width: 100%;
  height: 3px;
}

.run {
  width: 15px;
  height: 5px;
  top: 0;
  left: 0;
  position: absolute;
  background: blue;
  animation: loader 0.7s linear infinite alternate;
  -webkit-animation: loader 0.7s linear infinite alternate;
}

@keyframes loader {
  0% {
    left: 0;
  }

  100% {
    left: 85px;
  }
}
</style>









// WEBPACK FOOTER //
// src/views/customized-queries/components/queries-main.vue